var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_2403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35355 2.64645C6.256 2.56425 6.13155 2.51631 6.00245 2.51832C5.87339 2.52028 5.751 2.57126 5.66113 2.66113C5.57126 2.751 5.52028 2.87339 5.51832 3.00245C5.51631 3.13155 5.56425 3.256 5.64645 3.35355C5.79897 3.53436 5.9522 3.71446 6.10614 3.89386C7.49159 5.50841 8.93431 7.06569 10.4343 8.56569V7.43431C8.93431 8.93431 7.49159 10.4916 6.10614 12.1061C5.9522 12.2855 5.79897 12.4656 5.64645 12.6464C5.56425 12.744 5.51631 12.8684 5.51832 12.9976C5.52028 13.1266 5.57126 13.249 5.66113 13.3389C5.751 13.4287 5.87339 13.4797 6.00245 13.4817C6.13155 13.4837 6.256 13.4357 6.35355 13.3536C6.53436 13.201 6.71446 13.0478 6.89386 12.8939C8.50841 11.5084 10.0657 10.0657 11.5657 8.56569C11.8857 8.24569 11.8857 7.75431 11.5657 7.43431C10.0657 5.93431 8.50841 4.49159 6.89386 3.10614C6.71446 2.9522 6.53436 2.79897 6.35355 2.64645Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_2403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/CaretRight.d736731ba4df3966c8eb3503d3814d8a.svg";
export { ForwardRef as ReactComponent };